import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTopics, getTopics } from "../../../redux/slice/topicSlice";

import DynamicExamTopics from "./DynamicExamTopics";
import TopicList from "./TopicList";

const TopicChoice = () => {
  const dispatch = useDispatch();
  const topics = useSelector(getTopics);

  useEffect(() => {
    if (!topics) {
      dispatch(fetchTopics());
    }
  }, [dispatch, topics]);

  return (
    <section className="flex flex-col gap-6 w-full">
      <div className="flex flex-col sm:p-8 p-5 bg-primary rounded-[10px] border border-gray-300 shadow-md w-full gap-6">
        <DynamicExamTopics topics={topics} />
      </div>
      <div className="flex flex-col sm:p-8 p-5 bg-primary rounded-[10px] border border-gray-300 shadow-md w-full gap-6">
        <TopicList topics={topics} />
      </div>
    </section>
  );
};

export default TopicChoice;
